import { cn } from '~/shadcn/lib/utils'

export function TextTableHead({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('scroll-m-20 text-sm/relaxed font-semibold', className)}
      {...props}
    />
  )
}
